export default __webpack_public_path__ + "static/media/logo192x192.7180d25d.png";